export default "__VITE_ASSET__CR81ieZe__"